import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getType from 'lib/getType';
import Auth from 'modules/Auth';
import Wallet from 'modules/Wallet';
import Bingo from 'modules/Bingo';
import Chat from 'modules/Chat';

const modules = {
  Wallet: Wallet,
  Bingo: Bingo,
  Chat: Chat
};

const RETRY_INTERVAL = 10000;

// PureComponent: SIMPLE props only, ALL children must be PURE too!
export class _Online extends Component {
  constructor(props) {
    super(props);
    this.state = {
      online: navigator.onLine && this.providerLive(props.providerOnline)
    };
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    window.addEventListener('offline', this.updateOnline);
    window.addEventListener('online', this.updateOnline);
  }

  componentDidUpdate(prevProps, prevState) {
    const { providerOnline } = this.props;
    if (prevProps.providerOnline !== providerOnline) {
      this.updateOnline(null, providerOnline);
      if (!providerOnline) {
        this.providerOfflineCount++;
      }
    }

    if (prevState.online === this.state.online) return;
    if (!this.providerLive(this.state.online)) {
      this.interval = setInterval(this.props.retryConn, RETRY_INTERVAL);
    } else {
      clearInterval(this.interval);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    window.removeEventListener('offline', this.updateOnline);
    window.removeEventListener('online', this.updateOnline);
    clearInterval(this.interval);
  }

  providerLive = (provider) =>
    this.providerOfflineCount === 0 || provider === true || provider === null;

  updateOnline = (e, providerOnline) => {
    if (this.mounted) {
      this.setState({
        online:
          navigator.onLine &&
          this.providerLive(
            providerOnline !== undefined ? providerOnline : this.props.providerOnline
          )
      });
    }
  };

  render() {
    const { children } = this.props;
    return children(this.state.online);
  }
}

_Online.propTypes = {
  children: PropTypes.func.isRequired,
  retryConn: PropTypes.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  checkAuth: PropTypes.bool,
  providerOnline: PropTypes.bool
};

_Online.defaultProps = {
  checkAuth: false,
  providerOnline: false
};

const mapStateToProps = (state, { provider }) => ({
  providerOnline: state[provider].socket.connected
});

const mapDispatchToProps = (dispatch, { provider, checkAuth, subscription }) => ({
  retryConn: () => {
    const subscribe = modules[provider].actions.subscribe;
    if (checkAuth) dispatch(Auth.actions.checkAuth({ skipSession: true }));
    dispatch(getType(subscribe) === 'Function' ? subscribe(subscription) : subscribe);
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(_Online);
